export default __webpack_public_path__ + "static/media/carEX2.195aadc3.jpg";